import { TransportType } from '../../services/models';

export type TypeTransport = 'app' | 'public' | 'private' | null;

const mockTransport = (transport_type: TypeTransport | TransportType) => {
  switch (transport_type) {
    case 'private':
    case 'ownVehicle':
      return 'Condução Própria';
    case 'public':
    case 'publicTransportation':
      return 'Público';
    case 'app':
    case 'appOrTaxi':
      return 'Aplicativo';
    default:
      return '';
  }
};

export default mockTransport;
